import React, { useRef, useContext } from 'react';
import { QuickLinksContext } from './QuickLinksContext';
import { useDragHandler } from '../hooks/useDragHandler';
import LinkPill from './LinkPill';
import LinksSkeleton from './LinksSkeleton';

const LinksContent = () => {
  const { links, loading } = useContext(QuickLinksContext);
  const linksRef = useRef();
  const containerRef = useRef();

  useDragHandler(containerRef, linksRef);

  if (loading)
    return <LinksSkeleton />;

  return (
    <div
      className="sui-flex sui-flex-grow sui-overflow-hidden sui-relative sui-h-8 sui-touch-none"
      ref={containerRef}
      data-component="LinksContent"
    >
      <div
        role="navigation"
        ref={linksRef}
        className="sui-flex sui-px-2 sui-gap-4 sui-items-center sui-absolute sui-select-none"
      >
        {links?.map((link, index) => {
          return (
            <LinkPill
              key={`quick-link-${link.label}-${index}`}
              link={link}
              index={index}
            />
          );
        })}
      </div>
    </div>
  );
};

LinksContent.defaultProps = {
};

LinksContent.propTypes = {
};

export default LinksContent;
